import { AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClientPath } from '@shared/models/client-path.enum';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { Angulartics2Segment } from 'angulartics2';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'dbs-eligibility-check',
  templateUrl: './dbs-eligibility-check.component.html',
  styleUrls: ['./dbs-eligibility-check.component.scss'],
})
export class DbsEligibilityCheckComponent implements OnInit, AfterContentInit, OnDestroy {
  public dbsAmexEligibilityForm: UntypedFormGroup;
  public customVariables$: Observable<CustomisableVariables>;
  @Output() public changedEligibilityForm = new EventEmitter<any>();

  private eligibilityPanLength = 4;

  private unsubscribe$ = new Subject<void>();
  constructor(
    private siteSettingsService: SiteSettingsService,
    private customisableVariablesService: CustomisableVariablesService,
    private angulartics2Segment: Angulartics2Segment
  ) {
    this.customVariables$ = this.customisableVariablesService.variables;
  }

  public ngOnInit() {
    this.siteSettingsService
      .fetchSiteSettings()
      .pipe(
        filter((settings: ISiteSettings) => !!settings),
        map((settings: ISiteSettings) => settings.eligibility_pan_length),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((eligibilityPanLength) => (this.eligibilityPanLength = eligibilityPanLength));

    this.angulartics2Segment.eventTrack('EligibilityPageLoaded', { clientPath: ClientPath.DBSAMEX });
  }

  public ngAfterContentInit() {
    this.dbsAmexEligibilityForm = new UntypedFormGroup({
      indentifier: new UntypedFormControl('', [Validators.required]),
      indentifier2: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(this.eligibilityPanLength),
        Validators.maxLength(this.eligibilityPanLength),
        Validators.pattern(new RegExp(`^[0-9]{${this.eligibilityPanLength}}$`)),
      ]),
    });

    this.dbsAmexEligibilityForm.valueChanges
      .pipe(
        filter((value) => !!value),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        this.changedEligibilityForm.emit(this.dbsAmexEligibilityForm);
      });
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
